/**
 * Locale store — persists the user's language choice and applies it.
 * ko/en with gettext-style translation via @/lib/i18n (see CATALOGS there).
 */

const STORAGE_KEY = 'quay-locale'

export type Locale = 'ko' | 'en'

function readStored(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'ko' || stored === 'en') return stored
  } catch {
    // localStorage unavailable
  }
  // Default: Korean
  return 'ko'
}

let currentLocale: Locale = readStored()

/** Apply the locale to <html lang="..."> so the browser + screen readers know. */
function applyToDocument(locale: Locale): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'ko' ? 'ko-KR' : 'en-US'
  }
}

// Apply on module load
applyToDocument(currentLocale)

export function getLocale(): Locale {
  return currentLocale
}

export function setLocale(locale: Locale): void {
  currentLocale = locale
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // ignore
  }
  applyToDocument(locale)
}

export function isKorean(): boolean {
  return currentLocale === 'ko'
}
